import {
    Button,
    Stack,
    Text,
    type ButtonProps,
    type PolymorphicComponentProps,
} from '@mantine/core';
import type { Except, Merge } from 'type-fest';
import type { FormLike } from '../../../hooks/useMultiForm';

export const Form_SubmitButton = ({
    form: {
        formState: {
            isDirty,
            isSubmitting,
            errors: { root },
        },
        trigger,
    },
    canSubmitDefaultValue,
    ...props
}: Merge<
    Except<
        PolymorphicComponentProps<'button', ButtonProps>,
        'type' | 'disabled' | 'loading' | 'style'
    >,
    { form: FormLike; canSubmitDefaultValue: boolean }
>) => {
    const rootError = root?.message;

    return (
        <Stack
            gap={5}
            onMouseEnter={() => trigger()}
        >
            <Button
                {...props}
                type="submit"
                disabled={!canSubmitDefaultValue && !isDirty}
                loading={isSubmitting}
                style={rootError ? { borderColor: 'red' } : undefined}
            />
            {rootError && (
                <Text
                    c="red"
                    size="xs"
                >
                    {rootError}
                </Text>
            )}
        </Stack>
    );
};
